import { render } from "./RoleCompare.vue?vue&type=template&id=a9f53488"
import script from "./RoleCompare.vue?vue&type=script&lang=js"
export * from "./RoleCompare.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__